import { useState, memo } from 'react';

import Style from './Search.module.css';

import { Input } from '../../atoms/';

import { getLocationType } from '../../../utils/generic';

const getDataForDisplay = (query, filteredData, data) => {
  const max_items_to_display = 6;
  const res = [];

  if (query.length) {
    for (let i = 0; i < max_items_to_display; i++) {
      res.push(filteredData[i] || '');
    }
  } else {
    for (let i = 0; i < max_items_to_display; i++) {
      res.push(data[i] || '');
    }
  }

  return res;
};

const Search = memo(({ data, config, title }) => {
  const [query, setQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const handleSearch = (e) => {
    const { value } = e.target;

    if (value.length) {
      const new_data = data.filter((elm) => {
        if (config) {
          return elm[config.searchBy].toLowerCase().includes(value.toLowerCase());
        } else {
          return String(elm).toLowerCase().includes(value.toLowerCase());
        }
      });

      setFilteredData(new_data);
    }

    setQuery(value);
  };

  return (
    <>
      <Input onChange={handleSearch} placeholder={`Search by ${getLocationType(title)}`} value={query} />
      <div className='py-5'>
        <div className='row'>
          {getDataForDisplay(query, filteredData, data).map((elm, i) => (
            <div
              className={`
                ${Style.searchItems} col-12 gray mb-5 text-capitalize`}
              key={i}
            >
              {config ? elm[config.displayText] : elm}
            </div>
          ))}
        </div>
      </div>
    </>
  );
});

Search.displayName = 'Search';

Search.defaultProps = {
  config: null,
  data: []
};

export default Search;
